/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'star': {
    width: 26,
    height: 25,
    viewBox: '0 0 26 25',
    data: '<path pid="0" d="M24.234 8.344c1.219.187 1.688 1.687.797 2.578l-4.922 4.828 1.172 6.797c.188 1.219-1.125 2.156-2.203 1.594l-6.094-3.235-6.14 3.235c-1.078.562-2.391-.375-2.203-1.594l1.171-6.797-4.921-4.828c-.891-.89-.422-2.39.797-2.578l6.89-.985 3.047-6.234c.563-1.125 2.156-1.078 2.672 0l3.094 6.234zm-6.562 6.61l4.734-4.595-6.515-.937-2.907-5.906-2.953 5.906-6.515.937 4.734 4.594-1.125 6.469 5.859-3.047 5.813 3.047z" _fill="#000"/>'
  }
})
